import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-success-green",
  "use": "icon-success-green-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 17 16\" id=\"icon-success-green\"><path fill=\"#fff\" d=\"M.5 0h16v16H.5z\" opacity=\".01\" /><path fill=\"#36B37E\" fill-rule=\"evenodd\" d=\"M8.5 16a8 8 0 1 0 0-16 8 8 0 0 0 0 16\" clip-rule=\"evenodd\" /><path fill=\"#fff\" fill-rule=\"evenodd\" d=\"m7.826 10.876-.6.6L4.5 8.751 5.702 7.55l1.523 1.524L11.298 5 12.5 6.202z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol